function padDatePart(value)
{
    return value < 10 ? '0' + value : String(value);
}

export function formatDateForEnquiry(date)
{
    return [
        date.getFullYear(),
        padDatePart(date.getMonth() + 1),
        padDatePart(date.getDate()),
    ].join('/');
}

export function initArrivalDatepickers(root, options)
{
    if (!window.jQuery || !window.jQuery.fn.datepicker) {
        return;
    }

    var settings = options || {};
    var $ = window.jQuery;
    var $root = root ? $(root) : $(document);
    var $inputs = $root.is('.arrival_date') ? $root : $root.find('.arrival_date');
    var today = new Date();
    var minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);

    $inputs.each(function () {
        var input = this;
        var $input = $(input);

        $input.off('changeDate.sbArrivalDatepicker');
        $input.datepicker({
            format: settings.format || 'yyyy/mm/dd',
            autoclose: true,
            onRender: function (date) {
                return date.valueOf() < minDate.valueOf() ? 'disabled' : '';
            },
        });

        if (!settings.onChange) {
            return;
        }

        $input.on('changeDate.sbArrivalDatepicker', function (event) {
            settings.onChange(formatDateForEnquiry(event.date), event, input);

            if (settings.hideOnChange !== false) {
                $input.datepicker('hide');
            }
        });
    });
}
